var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleAltFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8916 10.9417C15.0333 11.7167 15.8333 12.7667 15.8333 14.1667V16.6667H19.1666V14.1667C19.1666 12.35 16.1916 11.275 13.8916 10.9417Z",
    fill: "#B6B4BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 10C9.34127 10 10.8337 8.50763 10.8337 6.66668C10.8337 4.82573 9.34127 3.33334 7.50033 3.33334C5.65938 3.33334 4.16699 4.82573 4.16699 6.66668C4.16699 8.50763 5.65938 10 7.50033 10Z",
    fill: "#84818A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4999 10C14.3416 10 15.8333 8.50834 15.8333 6.66668C15.8333 4.82501 14.3416 3.33334 12.4999 3.33334C12.1083 3.33334 11.7416 3.41668 11.3916 3.53334C12.0833 4.39168 12.4999 5.48334 12.4999 6.66668C12.4999 7.85001 12.0833 8.94168 11.3916 9.80001C11.7416 9.91668 12.1083 10 12.4999 10Z",
    fill: "#84818A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50016 10.8333C5.27516 10.8333 0.833496 11.95 0.833496 14.1667V16.6667H14.1668V14.1667C14.1668 11.95 9.72516 10.8333 7.50016 10.8333Z",
    fill: "#84818A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleAltFill);
export default __webpack_public_path__ + "static/media/people_alt_fill.115a63881b02819902268c8a81b574fd.svg";
export { ForwardRef as ReactComponent };